import "antd/es/col/style";
import _Col from "antd/es/col";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import './style/index';
import Typography from '../typography/index';

var IglooCardItem = function IglooCardItem(props) {
  var span = props.span,
      title = props.title,
      children = props.children;
  var className = props.className;

  function renderContent(children) {
    var type = _typeof(children);

    switch (type) {
      case 'boolean':
        return null;

      case 'string':
        return _jsx(Typography, {
          level: "body1",
          children: children
        });

      case 'number':
        return _jsx(Typography, {
          level: "body1",
          children: children
        });

      case 'object':
        return children;

      default:
        break;
    }
  }

  return _jsxs(_Col, {
    span: span || 4,
    className: classnames('igloofrom-card-detail-item', className),
    children: [_jsx("div", {
      className: "card-item-title",
      children: _jsx(Typography, {
        level: "body1",
        children: title
      })
    }), renderContent(children)]
  });
};

IglooCardItem.displayName = 'IglooCardItem';
export default IglooCardItem;